interface HealthMetricSvgProps {
    color?: string; // optional — lets you override the default color
}

export const HealthMetricSvg: React.FC<HealthMetricSvgProps> = ({ color }) => {
    const strokeColor = color || 'currentColor'; // use prop if provided, else currentColor

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
        >
            <path
                d="M12.6667 2.5H3.33333C2.59695 2.5 2 3.09695 2 3.83333V13.1667C2 13.903 2.59695 14.5 3.33333 14.5H12.6667C13.403 14.5 14 13.903 14 13.1667V3.83333C14 3.09695 13.403 2.5 12.6667 2.5Z"
                stroke={strokeColor}
                strokeWidth="0.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.3332 8.49984H9.99984L8.6665 11.8332L7.33317 5.1665L5.99984 8.49984H4.6665"
                stroke={strokeColor}
                strokeWidth="0.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};


export const BeaconSvg = ({ color }) => {
    const strokeColor = color || 'currentColor'; // use prop if provided, else currentColor
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.99971 9.19639C8.66079 9.19639 9.19669 8.66048 9.19669 7.99941C9.19669 7.33833 8.66079 6.80243 7.99971 6.80243C7.33864 6.80243 6.80273 7.33833 6.80273 7.99941C6.80273 8.66048 7.33864 9.19639 7.99971 9.19639Z" stroke={strokeColor} stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12.2426 12.2426C13.0818 11.4035 13.6532 10.3344 13.8847 9.17054C14.1162 8.00666 13.9974 6.80026 13.5433 5.7039C13.0892 4.60754 12.3201 3.67047 11.3334 3.01118C10.3467 2.35189 9.18669 2 8 2C6.81331 2 5.65327 2.35189 4.66658 3.01118C3.67988 3.67047 2.91085 4.60754 2.45672 5.7039C2.0026 6.80026 1.88378 8.00666 2.11529 9.17054C2.3468 10.3344 2.91824 11.4035 3.75736 12.2426" stroke={strokeColor} stroke-width="0.8" stroke-linecap="round" />
            <path d="M10.508 10.508C11.0041 10.012 11.3419 9.37999 11.4787 8.69196C11.6156 8.00393 11.5453 7.29078 11.2769 6.64267C11.0084 5.99456 10.5538 5.44062 9.97054 5.05088C9.38726 4.66115 8.70151 4.45313 8 4.45313C7.29849 4.45312 6.61274 4.66115 6.02946 5.05088C5.44618 5.44062 4.99157 5.99456 4.72311 6.64267C4.45466 7.29078 4.38442 8.00393 4.52128 8.69196C4.65813 9.37999 4.99594 10.012 5.49198 10.508" stroke={strokeColor} stroke-width="0.8" stroke-linecap="round" />
        </svg>

    )
}

export const InvalidTmSvg = ({ color }) => {
    const strokeColor = color || 'currentColor'; // use prop if provided, else currentColor
    return (

        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <path d="M12.8594 11.4965L8.86259 4.50203C8.77544 4.34825 8.64906 4.22035 8.49634 4.13136C8.34363 4.04237 8.17004 3.99548 7.99328 3.99548C7.81653 3.99548 7.64294 4.04237 7.49022 4.13136C7.3375 4.22035 7.21112 4.34825 7.12398 4.50203L3.12716 11.4965C3.03907 11.649 2.99288 11.8221 2.99327 11.9983C2.99366 12.1745 3.04062 12.3474 3.12938 12.4996C3.21815 12.6517 3.34556 12.7777 3.49871 12.8648C3.65187 12.9518 3.82531 12.9968 4.00147 12.9953H11.9951C12.1704 12.9951 12.3426 12.9488 12.4943 12.861C12.6461 12.7732 12.7721 12.6471 12.8597 12.4952C12.9472 12.3433 12.9933 12.1711 12.9933 11.9958C12.9932 11.8205 12.9471 11.6483 12.8594 11.4965Z" stroke={strokeColor} stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M7.9984 7V8.99841" stroke={strokeColor} stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M7.9984 10.9968H8.00339" stroke={strokeColor} stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}

export const ArrowUp = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
        <path d="M12 19V5M5 12l7-7 7 7" />
    </svg>
);

export const CurlyBraces = () => (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M5.33333 2H4.66667C4.31304 2 3.97391 2.14048 3.72386 2.39052C3.47381 2.64057 3.33333 2.97971 3.33333 3.33333V6.66667C3.33333 7.02029 3.19286 7.35943 2.94281 7.60948C2.69276 7.85952 2.35362 8 2 8C2.35362 8 2.69276 8.14048 2.94281 8.39052C3.19286 8.64057 3.33333 8.97971 3.33333 9.33333V12.6667C3.33333 13.4 3.93333 14 4.66667 14H5.33333" stroke="#f0f0f0" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M10.667 14H11.3337C11.6873 14 12.0264 13.8595 12.2765 13.6095C12.5265 13.3594 12.667 13.0203 12.667 12.6667V9.33333C12.667 8.6 13.267 8 14.0003 8C13.6467 8 13.3076 7.85952 13.0575 7.60948C12.8075 7.35943 12.667 7.02029 12.667 6.66667V3.33333C12.667 2.97971 12.5265 2.64057 12.2765 2.39052C12.0264 2.14048 11.6873 2 11.3337 2H10.667" stroke="#f0f0f0" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
</svg>)

export const FilterSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g opacity="0.6">
            <path d="M1.5 8H14.5" stroke="#F0F0F0" stroke-width="0.975" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8.00183 1.5V14.5" stroke="#F0F0F0" stroke-width="0.975" stroke-linecap="round" stroke-linejoin="round" />
        </g>
    </svg>
)

export const FilterDropdownArrowSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <g opacity="0.6">
            <path d="M4 6L8 10L12 6" stroke="#F0F0F0" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
        </g>
    </svg>
);

export const FilterDeleteSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
        <path d="M0.5 3H9.5" stroke="currentColor" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M8.50049 3V10C8.50049 10.5 8.00049 11 7.50049 11H2.50049C2.00049 11 1.50049 10.5 1.50049 10V3" stroke="currentColor" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M3.00049 3V2C3.00049 1.5 3.50049 1 4.00049 1H6.00049C6.50049 1 7.00049 1.5 7.00049 2V3" stroke="currentColor" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

export const ApplyButton = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9" fill="none">
        <path d="M10.25 0.597656L4.6286 8.40426L1.25 5.08317" stroke="currentColor" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
)

export const SubsystemNodeIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
        <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
        <line x1="12" y1="22.08" x2="12" y2="12" />
    </svg>
)

export const ChannelNodeIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="8" y1="6" x2="21" y2="6" />
        <line x1="8" y1="12" x2="21" y2="12" />
        <line x1="8" y1="18" x2="21" y2="18" />
        <line x1="3" y1="6" x2="3.01" y2="6" />
        <line x1="3" y1="12" x2="3.01" y2="12" />
        <line x1="3" y1="18" x2="3.01" y2="18" />
    </svg>
)

export const SensorNodeIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <circle cx="12" cy="12" r="3" />
    </svg>
)